var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',_vm._l((_vm.locales),function(locale){return _c('li',[_c('a',{attrs:{"href":_vm.getLink(locale)}},[_c('country-flag',{attrs:{"rounded":"","country":locale === 'en' ? 'us' : locale}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }